import { Nemesis } from '../../../../aer-types/types'

export const nemeses: Nemesis[] = [
  {
    expansion: 'AE',
    name: 'Carapax-Königin',
    id: 'CarapaceQueen',
    health: 60,
    difficulty: 3,
    expeditionRating: 1,
    additionalInfo: '',
  },
  {
    expansion: 'AE',
    name: 'König der Masken',
    id: 'CrookedMask',
    health: 70,
    difficulty: 5,
    expeditionRating: 2,
    additionalInfo: '',
  },
  {
    expansion: 'AE',
    name: 'Der Unersättliche',
    id: 'PrinceOfGluttons',
    health: 70,
    difficulty: 5,
    expeditionRating: 2,
    additionalInfo: '',
  },
  {
    expansion: 'AE',
    name: 'Hassgeburt',
    id: 'Rageborne',
    health: 70,
    difficulty: 2,
    expeditionRating: 1,
    additionalInfo: '',
  },
]
